// src/components/infografia/properties/IconProperties.jsx
import React, { useState } from 'react';
import { FaIcons, FaPalette } from 'react-icons/fa';
import IconSelectorModal from '../modals/IconSelectorModal';

const IconProperties = ({ element, onUpdate, onOpenIconSelector }) => {
    const props = element.propiedades || {};
    const [showIconSelector, setShowIconSelector] = useState(false);

    const handleChange = (field, value) => {
        const updates = {
            propiedades: {
                ...props,
                [field]: value
            }
        };

        // Si cambia el tamaño, también actualizar las dimensiones del elemento
        if (field === 'tamaño') {
            updates.dimensiones = {
                ancho: value,
                alto: value
            };
        }

        onUpdate(updates);
    };

    const handleSelectIcon = (iconData) => {
        // Actualizar todas las propiedades de una vez
        onUpdate({
            propiedades: {
                ...props,
                nombre: iconData.name,
                libreria: iconData.library,
                prefijo: iconData.prefix
            }
        });
    };

    // Función para renderizar el icono actual
    const renderCurrentIcon = () => {
        if (!props.nombre || !props.libreria) {
            return null;
        }

        try {
            const libraryMap = {
                'Font Awesome': require('react-icons/fa'),
                'Material Design': require('react-icons/md'),
                'Heroicons': require('react-icons/hi'),
                'Ionicons': require('react-icons/io5')
            };

            const IconLibrary = libraryMap[props.libreria];
            if (IconLibrary && IconLibrary[props.nombre]) {
                const IconComponent = IconLibrary[props.nombre];
                return <IconComponent className="text-4xl" style={{ color: props.color || '#000000' }} />;
            }
        } catch (error) {
            console.error('Error renderizando icono:', error);
        }
        return null;
    };

    return (
        <div className="space-y-4">
            {/* Seleccionar Icono */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Icono
                </label>

                {props.nombre ? (
                    <div className="space-y-2">
                        {/* Mostrar icono seleccionado */}
                        <div className="p-4 bg-gray-50 border border-gray-200 rounded-md flex items-center justify-center">
                            {renderCurrentIcon() || (
                                <span className="text-gray-400">Icono no disponible</span>
                            )}
                        </div>
                        <div className="text-xs text-gray-500 text-center">
                            {props.nombre} ({props.libreria})
                        </div>
                        <button
                            onClick={() => {
                                if (onOpenIconSelector) {
                                    onOpenIconSelector();
                                } else {
                                    setShowIconSelector(true);
                                }
                            }}
                            className="w-full px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 flex items-center justify-center gap-2"
                        >
                            <FaIcons />
                            Cambiar Icono
                        </button>
                    </div>
                ) : (
                    <button
                        onClick={() => {
                            if (onOpenIconSelector) {
                                onOpenIconSelector();
                            } else {
                                setShowIconSelector(true);
                            }
                        }}
                        className="w-full px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 flex items-center justify-center gap-2"
                    >
                        <FaIcons />
                        Seleccionar Icono
                    </button>
                )}
            </div>

            {/* Icon Selector Modal */}
            {!onOpenIconSelector && (
                <IconSelectorModal
                    isOpen={showIconSelector}
                    onClose={() => setShowIconSelector(false)}
                    onSelectIcon={handleSelectIcon}
                />
            )}

            {/* Color */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Color
                </label>
                <div className="flex items-center gap-2">
                    <input
                        type="color"
                        value={props.color || '#000000'}
                        onChange={(e) => handleChange('color', e.target.value)}
                        className="w-12 h-12 border border-gray-300 rounded cursor-pointer"
                    />
                    <input
                        type="text"
                        value={props.color || '#000000'}
                        onChange={(e) => handleChange('color', e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </div>

            {/* Tamaño */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tamaño: {props.tamaño || 100}px
                </label>
                <input
                    type="range"
                    min="20"
                    max="500"
                    value={props.tamaño || 100}
                    onChange={(e) => handleChange('tamaño', parseInt(e.target.value))}
                    className="w-full"
                />
            </div>

            {/* Opacidad */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Opacidad: {Math.round((props.opacidad || 1) * 100)}%
                </label>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={(props.opacidad || 1) * 100}
                    onChange={(e) => handleChange('opacidad', parseFloat(e.target.value) / 100)}
                    className="w-full"
                />
            </div>
        </div>
    );
};

export default IconProperties;

